import React, { useRef } from 'react';
import './contact.css';
import Walmart from '../../assets/walmart.png';
import Adobe from '../../assets/adobe.png';
import Microsoft from '../../assets/microsoft.png';
import Facebook from '../../assets/facebook.png';
import FacebookIcon from '../../assets/facebook-icon.png';
import TwitterIcon from '../../assets/twitter.png';
import YouTubeIcon from '../../assets/youtube.png';
import InstagramIcon from '../../assets/instagram.png';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_c7mp71a', 'template_rmzftu9', form.current, 'jC02DJd_LkBN28-bD')
      .then((result) => {
          console.log(result.text);
          e.target.reset();
          alert('Your Message to Ratan has been sent. Thank You. Har Har Mahadev');
            }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <section id='contactPage'>
        <div className='clients'>
           <h1 className='contactPageTitle'>Achievements</h1>
           <p className='clientDesc'>
           </p>
           <div className='clientImgs'>
                <img src={Walmart} alt='Client' className='clientImg1'></img>
                <img src={Adobe} alt='Client' className='clientImg'></img>
                <img src={Microsoft} alt='Client' className='clientImg'></img>
                <img src= {Facebook} alt='Client' className='clientImg'></img>
                
           </div>
        </div>
                
        <div id='contact'>
               <h1 className='contactPageTitle'>Contact Me</h1>
                <span className='contactDesc'>Please fill out the form below to contact me.</span>
                {/* <form className='contactForm' ref={form} onSubmit={sendEmail}>
                     <input type='text' className='name' placeholder='Your Name' name='your_name'></input>
                     <input type='email' className='email' placeholder='Your Email' name='your_email'></input>
                     <textarea className='msg' name='message' rows='5' placeholder='Your Message'></textarea>
                     <button type='submit' value='Send' className='submitBtn'>Submit</button>
                </form> */}
                <form className='contactForm' ref={form} onSubmit={sendEmail}>
    <input type='text' className='name' placeholder='Your Name' name='your_name' required></input>
    <input type='email' className='email' placeholder='Your Email' name='your_email' required></input>
    <textarea className='msg' name='message' rows='5' placeholder='Your Message' required></textarea>
    <button type='submit' value='Send' className='submitBtn'>Submit</button>
</form>

                <div className='links'>
                  <h6>Get in touch with me on these #Social Media handles </h6><br></br>
                <a href="https://www.linkedin.com/in/ratanojha/" target="_blank" rel="noreferrer"><img src={FacebookIcon} alt='Linkedin' className='link'></img></a>
                <a href="https://twitter.com/krratan2" target="_blank" rel="noreferrer"> <img src={TwitterIcon} alt='twitter' className='link'></img></a>
                <a href="https://www.youtube.com/@Ratankumarojha" target="_blank" rel="noreferrer"><img src={YouTubeIcon} alt='Youtube' className='link'></img></a>
                <a href="https://www.instagram.com/ratan_ojha_/" target="_blank" rel="noreferrer"><img src={InstagramIcon} alt='Instagram' className='link'></img></a>
                </div>
        </div>

    </section>
  );
}

export default Contact;